<template>
  <div class="is-absolute xy-r-20 xy-t-20 is-size-5 delayed-show-rl">
    {{ $t('Press ') }}
    <i class="tag is-info is-light has-text-weight-semibold px-1">{{ command }}</i>
    {{ suffix }}
  </div>
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'SpotlightSearchInputTip',
  props: {
    command: { type: String, required: true },
    suffix: { type: String, required: true }
  }
};
</script>
